{
  "DATA_ASSISTANT": {
    "TITLE": "مساعد البيانات",
    "NEW_CONVERSATION": "+ جديد",
    "LOADING": "جارٍ التحميل...",
    "LOADING_MESSAGES": "جارٍ تحميل الرسائل...",
    "THINKING": "جارٍ التفكير...",
    "UNTITLED": "محادثة بلا عنوان",
    "NO_CONVERSATIONS": "لا توجد محادثات بعد. انقر على \"+ جديد\" للبدء.",
    "EMPTY_STATE": "حدد محادثة أو أنشئ محادثة جديدة للبدء.",
    "PLACEHOLDER": "ما الذي تريد أن تعرفه؟",
    "SHOW_SQL": "إظهار SQL",
    "NO_ROWS": "لم يتم إرجاع أي صفوف.",
    "DELETE": "×",
    "DELETE_CONFIRM": "حذف المحادثة",
    "DELETE_CONFIRM_DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.",
    "DELETE_CONFIRM_YES": "حذف",
    "REPORTS": "التقارير",
    "SAVE_TO_REPORT": "حفظ في تقرير",
    "NEW_REPORT": "تقرير جديد",
    "REPORT_NAME": "اسم التقرير",
    "NO_REPORTS": "لا توجد تقارير محفوظة بعد",
    "REPORTS_EMPTY_STATE": "حدد تقريراً أو أنشئ تقريراً جديداً.",
    "REPORT_SAVED": "تم الحفظ في التقرير",
    "DELETE_REPORT_CONFIRM": "حذف التقرير",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "هل أنت متأكد أنك تريد حذف هذا التقرير؟ سيتم إزالة جميع العناصر المحفوظة فيه.",
    "DELETE_ITEM_CONFIRM": "إزالة العنصر",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "هل أنت متأكد أنك تريد إزالة هذا العنصر من التقرير؟",
    "EXPORT_CSV": "تصدير CSV",
    "REFRESH": "تحديث",
    "QUERY_RUNNING": "جارٍ تنفيذ الاستعلام...",
    "QUERY_FAILED": "فشل الاستعلام",
    "AUTO_REFRESH": "التحديث التلقائي",
    "AUTO_REFRESH_NONE": "يدوي",
    "AUTO_REFRESH_30S": "30 ثانية",
    "AUTO_REFRESH_1M": "دقيقة واحدة",
    "AUTO_REFRESH_5M": "5 دقائق",
    "AUTO_REFRESH_10M": "10 دقائق",
    "EDIT_MESSAGE": "تعديل الرسالة",
    "RENAME_REPORT": "إعادة تسمية التقرير",
    "RENAME_ITEM": "إعادة تسمية العنصر",
    "MOVE_UP": "نقل لأعلى",
    "MOVE_DOWN": "نقل لأسفل",
    "COLLABORATORS": {
      "BUTTON": "المتعاونون",
      "TITLE": "المتعاونون في التقرير",
      "DESCRIPTION": "اختر الوكلاء والفرق الذين يمكنهم عرض هذا التقرير.",
      "AGENTS": "الوكلاء",
      "TEAMS": "الفرق",
      "SELECT_AGENTS": "اختر الوكلاء",
      "SELECT_TEAMS": "اختر الفرق",
      "SAVE": "حفظ",
      "SAVED": "تم تحديث المتعاونين",
      "SAVE_FAILED": "تعذر تحديث المتعاونين"
    }
  }
}
